import { Skeleton, Stack, Typography } from '@mui/material';
import DeviceManager from '@/components/util/deviceManager';

export const SkeletonPathItem = () => {
  return (
    <Stack
      width="100%"
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      height="82px"
      px="20px"
      sx={{
        borderTop: { xs: 'none', lg: '1px solid #D0D5DD' },
      }}
    >
      <Stack direction="row" alignItems="center">
        <Stack
          width="38px"
          height="38px"
          alignItems="center"
          justifyContent="center"
          overflow="hidden"
          sx={{
            background: 'transparent',
            borderRadius: '8px',
            p: 0,
            mr: '14px',
            ml: '0',
            border: '1px solid #E8E8E8',
          }}
        >
          <Skeleton variant="rounded" height={38} width={38} />
        </Stack>
        <Stack>
          <Typography fontSize="16px" fontWeight={500}>
            <Skeleton
              variant="text"
              sx={{ fontSize: '16px' }}
              width={DeviceManager.isMobile() ? 100 : 230}
            />
          </Typography>
          <Typography fontSize="14px" fontWeight={400}>
            <Skeleton
              variant="text"
              sx={{ fontSize: '16px' }}
              width={DeviceManager.isMobile() ? 80 : 180}
            />
          </Typography>
        </Stack>
      </Stack>
      <Stack
        sx={{
          display: { xs: 'none', lg: 'flex' },
          ':hover': {
            background: 'rgba(32, 85, 255, 0.06)',
          },
        }}
      ></Stack>
      <Stack direction="row" gap="10px" alignItems="center" width="128px" justifyContent="flex-end">
        <Skeleton variant="rounded" width={36} height={8} />
      </Stack>
    </Stack>
  );
};
